export default "/images/vendor/flag-icon-css/flags/4x3/mu.svg?97beced41b168e88e8fb1d9562264d1d";